import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonLink } from '@yonderland/andes-react';
import { useMemo } from 'react';
import { useOAuth } from '../../hooks/useOAuth';
import { buildDiscountVoucherRedirectLocation, buildRIVoucherRedirectLocation, hasValidVoucherData, } from './voucher-activation.utils';
const VoucherActivation = ({ activationId, buttonLabel, discountVoucherId, returnIncentiveId, url, voucherType, }) => {
    const { userInfo } = useOAuth();
    const createRedirectLocation = useMemo(() => {
        var _a;
        const customerUuid = (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.sub) !== null && _a !== void 0 ? _a : '';
        switch (voucherType) {
            case 'discountVoucher': {
                return buildDiscountVoucherRedirectLocation({
                    url,
                    customerUuid,
                    discountVoucherId,
                    activationId,
                });
            }
            case 'riVoucher': {
                return buildRIVoucherRedirectLocation({ url, customerUuid, returnIncentiveId });
            }
        }
    }, [userInfo, url, voucherType, activationId, discountVoucherId, returnIncentiveId]);
    if (!url || !hasValidVoucherData({ voucherType, activationId, discountVoucherId, returnIncentiveId })) {
        return null;
    }
    return (_jsx(ButtonLink, { fullWidth: true, theme: "branded", href: createRedirectLocation, children: buttonLabel }));
};
export default VoucherActivation;
